import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import {
  EmptyStateWrapper,
  FlexBox,
  SpacingBox,
  InlineProductList,
  TextOnlyUnderlinedButton,
} from '../Components';

import { getInitialSlice } from '../utils/collections';
import { getTranslateByScope } from '../i18n';

const translate = getTranslateByScope('app.productSearchPreview');

const SeeAllResults = (props) => (
    <TextOnlyUnderlinedButton
      text={translate('seeAllResultsText')}
      onClick={() => {
        props.onRouteToAllResults();
        props.push(`/productList?search=${props.search}`);
      }}
    />
);

const ProductSearchPreview = withRouter(
  ({
    history,
    products,
    search,
    onClick,
    onRouteToAllResults,
    totalDisplayed,
  }) => (
    <>
      <SpacingBox margin="sm">
        <EmptyStateWrapper
          title={translate('emptyState.title')}
          description={translate('emptyState.description')}
          condition={products && _.size(products.data)}>
          {() => (
            <FlexBox marginTop="lg" flexDirection="column" alignItems="center">
              {!!search && (
              <InlineProductList
                products={getInitialSlice(products.data, totalDisplayed)}
                onClick={(number) => {
                  onClick(number);
                }}
              />
              )}
              {onRouteToAllResults && (
                <SpacingBox marginLeft="sm">
                  <SeeAllResults
                    push={history.push}
                    search={search}
                    onRouteToAllResults={onRouteToAllResults}
                  />
                </SpacingBox>
              )}
            </FlexBox>
          )}
        </EmptyStateWrapper>
      </SpacingBox>
    </>
  ),
);

ProductSearchPreview.defaultProps = {
  totalDisplayed: 60,
};

export default ProductSearchPreview;
